import React from "react";
import "./VisitingTemple.css";

function VisitingTemple() {
    return (
        <section id="steps-1712">
            <picture className="cs-background">
                <source media="(max-width: 600px)"
                        srcSet="/images/location-directions.jpg"></source>
                <source media="(min-width: 601px)"
                        srcSet="/images/location-directions.jpg"></source>
                <img loading="lazy" decoding="async"
                        src="/images/location-directions.jpg"
                        alt="busines meeting" width="522" height="609" aria-hidden="true"></img>
            </picture>
            <div className="cs-container">
                <div className="cs-wrapper">
                    <div className="cs-content">
                        <span className="cs-topper">Your Spiritual Steps</span>
                        <h2 className="cs-title">How To Get Started</h2>
                    </div>
                    <ul className="cs-card-group">
                        <li className="cs-item">
                            <span className="cs-number">01</span>
                            <div className="cs-flex">
                                <h3 className="cs-h3">Visit the Temple</h3>
                                <p className="cs-item-text">
                                Experience the peaceful atmosphere and connect with the divine presence.
                                </p>
                            </div>
                        </li>
                        <li className="cs-item">
                            <span className="cs-number">02</span>
                            <div className="cs-flex">
                                <h3 className="cs-h3">Join a Kirtan</h3>
                                <p className="cs-item-text">
                                Chant the Hare Krishna mantra with the community and feel the joy of devotion.
                            </p>
                            </div>
                        </li>
                        <li className="cs-item">
                            <span className="cs-number">03</span>
                            <div className="cs-flex">
                                <h3 className="cs-h3">Serve and Volunteer</h3>
                                <p className="cs-item-text">
                                    Participate in temple services or help in the kitchen — a great way to grow spiritually.
                                </p>
                            </div>
                        </li>
                        <li className="cs-item">
                            <span className="cs-number">04</span>
                            <div className="cs-flex">
                                <h3 className="cs-h3">Make a Commitment</h3>
                                <p className="cs-item-text">
                                Take small daily steps like chanting, reading, and praying to nurture your journey.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
}
export default VisitingTemple;